import React, { useState } from 'react';
import Select from 'react-select';

const CustomSelect = () => {
  const [inputValue, setInputValue] = useState('');
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
  };

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
  };

  const handleMenuOpen = () => {
    // Reset input value when the menu opens
    setInputValue('');
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: '1px solid #ccc',
      borderRadius: '4px',
      width: '300px',
    }),
  };

  return (
    <Select
      options={[]}
      value={selectedOptions}
      onChange={handleChange}
      onInputChange={handleInputChange}
      onMenuOpen={handleMenuOpen}
      inputValue={inputValue}
      isSearchable
      placeholder="Type to search..."
      styles={customStyles}
      // Additional props as needed
    />
  );
};

export default CustomSelect;
